import { gql } from '@apollo/client'

export const RUN_INSURANCE_BENEFITS_CHECK = gql`
  mutation runInsuranceBenefitsCheck(
    $addressState: AddressState!
    $insurancePolicyKind: UserInsurancePolicyKind!
    $insuranceVideoCallGoal: String!
    $insuranceVideoCallGoalOther: String
    $memberId: String
    $useInsuranceData: Boolean
  ) {
    runInsuranceBenefitsCheck(
      addressState: $addressState
      insurancePolicyKind: $insurancePolicyKind
      insuranceVideoCallGoal: $insuranceVideoCallGoal
      insuranceVideoCallGoalOther: $insuranceVideoCallGoalOther
      memberId: $memberId
      useInsuranceData: $useInsuranceData
    ) {
      dateOfBirth
      sex
      firstName
      lastName
      memberId
      groupNumber
      holderRelationship
      holderFirstName
      holderLastName
      holderDateOfBirth
    }
  }
`
